import React, {Component} from 'react';
import './App.css';
import ApplicationForm from './component/ApplicationForm';
import ApplicantFormSuccessPage from './component/ApplicantFormSuccessPage';
import VerificationSuccessPage from './component/registration/VerificationSuccessPage';
import VerifyApplicant from './component/registration/VerifyApplicant';
import LoginPage from './component/registration/LoginPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './component/Home';


class App extends Component {
  
    render() {
      return (
        <BrowserRouter>
        <div>
              <Routes>
                <Route path="/login" element={<LoginPage /> } />
                <Route path="/verifyemail" element={<VerifyApplicant /> } />
                <Route path="/verificationsuccesspage" element={<VerificationSuccessPage /> } />
                <Route path="/applicantformsuccesspage" element={<ApplicantFormSuccessPage /> } />
                <Route index element ={<Home/> } />
                <Route path="/apply" element={<ApplicationForm /> } />
              </Routes>
        </div>
         </BrowserRouter>
      );
}

}


export default App;

